module.exports = __webpack_public_path__ + "img/fushimi-HP-header.6af37f26.jpg";